export enum RecordingStatus {
  NOT_STARTED,
  LOADING,
  COUNTDOWN,
  RECORDING,
  PAUSED,
  STOPPED,
}
